import { BottomSheet, Button, Divider, getSpacing, rahtabCardId, Text, TextInput } from '@rahtab/ui';
import QRScanner from '@rahtab/ui/dist/animations/qrScanner/QRScannerLottie';
import CardsManagementIcon from '@rahtab/ui/dist/icons/CardsManagementIcon';
import React, { useEffect, useState, VFC } from 'react';
import { StyleSheet, View } from 'react-native';
import * as yup from 'yup';

const MemoQRScanner = React.memo(QRScanner);
const QRScannerBottomSheet: VFC<RahtabCardModalProps> = ({ onRequestClose, onSubmit, visible }) => {
  const [cardId, setCardId] = useState('');
  useEffect(() => {
    setCardId('');
  }, [visible]);
  const validateRahtabCardId = () => {
    if (rahtabCardId.required().isValidSync(cardId)) {
      onSubmit && onSubmit(cardId);
      onRequestClose && onRequestClose();
    }
  };
  return (
    <BottomSheet
      visible={visible}
      onRequestClose={onRequestClose}
      contentHeader={
        <>
          <CardsManagementIcon
            style={StyleSheet.flatten([styles.saleTitle, { marginBottom: getSpacing() }])}
            height={100}
            width={100}
          />
          <Text color="primary" variant="title" style={styles.saleTitle}>
            ثبت فروش با رهتاب کارت
          </Text>
        </>
      }>
      <View style={styles.qrBottomSheet}>
        <Text variant="cardTitle">1. ورود شناسه رهتاب کارت</Text>
        <TextInput
          label="شناسه"
          onSubmitEditing={validateRahtabCardId}
          maxLength={12}
          keyboardType="numeric"
          placeholder="شناسه رهتاب کارت خریدار را وارد نمایید."
          value={cardId}
          onChangeText={setCardId}
        />
        <Button
          onPress={() => {
            validateRahtabCardId();
          }}
          disabled={!rahtabCardId.required().isValidSync(cardId)}
          color="primary"
          text="ثبت اطلاعات"
        />
        <Divider />
        <Text variant="cardTitle" margin="none">
          2. اسکن بارکد رهتاب کارت
        </Text>
        <MemoQRScanner />
        <View style={styles.rowView}>
          {/* <Button
          variant="outlined"
          color="secondary"
          text="فعال‌سازی"
          style={{ flex: 1, marginRight: getSpacing(0.66) }}
        /> */}
          <Button
            onPress={() => {
              onRequestClose && onRequestClose();
            }}
            screenName="QRScanner"
            color="secondary"
            text="بارکدخوان"
            // eslint-disable-next-line react-native/no-inline-styles
            style={{ flex: 1.6 }}
          />
        </View>
      </View>
    </BottomSheet>
  );
};

export default QRScannerBottomSheet;

const styles = StyleSheet.create({
  barcodeImage: {
    height: 100,
    width: 100,
  },
  saleTitle: {
    alignSelf: 'center',
  },
  rowView: {
    flexDirection: 'row',
  },
  qrBottomSheet: {
    margin: getSpacing(),
    alignSelf: 'center',
    width: '100%',
  },
});

interface RahtabCardModalProps {
  visible?: boolean;
  onRequestClose?: () => void;
  onSubmit?: (code: string) => void;
}
